import React from "react";
import { faCalendarAlt, faPiggyBank } from "@fortawesome/pro-regular-svg-icons";
import {
    faFemale,
    faMale,
    faGraduationCap,
    faCalendarDay,
    faChartLine,
    faUserTag,
    faBuilding
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "../../styles/components/QuoteCell.css";

export const endash = "\u2013";

export const GENDER = {
    id: 2,
    sortOrder: 1,
    segments: [
        { id: 7, label: "Female", icon: faFemale },
        { id: 8, label: "Male", icon: faMale }
    ]
};

export const AGE = {
    id: 3,
    sortOrder: 2,
    icon: faCalendarAlt,
    segments: [
        { id: 11, label: `18${endash}24` },
        { id: 10, label: `25${endash}34` },
        { id: 15, label: `35${endash}44` },
        { id: 14, label: `45${endash}54` },
        { id: 13, label: `55+` }
    ]
};

export const INCOME = {
    id: 1,
    sortOrder: 3,
    icon: faPiggyBank,
    segments: [
        { id: 2, label: `$0${endash}$49k` },
        { id: 6, label: `$50k${endash}$99k` },
        { id: 5, label: `$100k${endash}$149k` },
        { id: 4, label: `$150k+` }
    ]
};

export const EDUCATION = {
    id: 4,
    sortOrder: 4,
    icon: faGraduationCap,
    segments: [
        { id: 16, label: "Some High School" },
        { id: 17, label: "High School Diploma/GED" },
        { id: 18, label: "Some College" },
        { id: 19, label: "Associate's Degree" },
        { id: 20, label: "Bachelor's Degree or Higher" }
    ]
};

export const B2BAGE = {
    id: 5,
    sortOrder: 5,
    icon: faCalendarDay,
    segments: [
        { id: 74, label: "Less than 1 year" },
        { id: 75, label: `1${endash}2 years` },
        { id: 105, label: `1${endash}3 years` }, // new id
        { id: 76, label: `3${endash}5 years` },
        { id: 77, label: `6${endash}9 years` },
        { id: 106, label: `7${endash}10 years` }, // new id
        { id: 78, label: `10+ years` }
    ]
};

export const B2BREVENUE = {
    id: 6,
    sortOrder: 6,
    icon: faChartLine,
    segments: [
        { id: 36, label: "<$50k" },
        { id: 37, label: `$50k ${endash} <$250k` },
        { id: 38, label: `$250k ${endash} <$500k` },
        { id: 107, label: "<$500k" }, // new id
        { id: 39, label: `$500k ${endash} <$750k` },
        { id: 40, label: `$750k ${endash} <$1M` },
        { id: 108, label: `$500k ${endash} <$1M` }, // new id
        { id: 41, label: `$1M ${endash} <$2M` },
        { id: 42, label: `$2M ${endash} <$5M` },
        { id: 43, label: `$5M ${endash} <$10M` },
        { id: 110, label: "$10M+" }, // new id
        { id: 44, label: `$10M ${endash} <$25M` },
        { id: 45, label: `$25M ${endash} <$50M` },
        { id: 46, label: `$50M ${endash} <$100M` },
        { id: 47, label: `$100M ${endash} <$500M` },
        { id: 48, label: `$500M ${endash} <$1B` },
        { id: 49, label: `$1B ${endash} <$10B` },
        { id: 50, label: "$10B+" }
    ]
};

export const B2BROLE = {
    id: 6,
    sortOrder: 6,
    icon: faUserTag,
    segments: [
        { id: 52, label: "Business Owner" },
        { id: 53, label: "Senior Management" },
        { id: 54, label: "Middle Management" },
        { id: 55, label: "Front Line Management" },
        { id: 56, label: "Experienced: Professional or Non-Management" },
        { id: 57, label: "Entry Level" },
        { id: 58, label: "Home Based Business Owner" },
        { id: 110, label: "Owner / Partner" }, // new id
        { id: 59, label: "Other" }
    ]
};

export const B2BSIZE = {
    id: 7,
    sortOrder: 7,
    icon: faBuilding,
    segments: [
        { id: 60, label: "1" },
        { id: 111, label: `2${endash}10` }, // new id
        { id: 61, label: `2${endash}5` },
        { id: 62, label: `6${endash}9` },
        { id: 63, label: `10${endash}49` },
        { id: 64, label: `50${endash}99` },
        { id: 65, label: `100${endash}249` },
        { id: 66, label: `250${endash}499` },
        { id: 67, label: `500${endash}999` },
        { id: 112, label: "1000+" }, // new id
        { id: 68, label: `1,000${endash}2,499` },
        { id: 69, label: `2,500${endash}4,999` },
        { id: 70, label: `5,000${endash}9,999` },
        { id: 71, label: `10,000${endash}24,999` },
        { id: 72, label: "25,000+" }
    ]
};

export const AUDIENCES = [
    GENDER,
    AGE,
    INCOME,
    EDUCATION,
    B2BAGE,
    B2BREVENUE,
    B2BROLE,
    B2BSIZE
];

export const SEGMENT_DICT = AUDIENCES.reduce((dict, audience) => {
    audience.segments.forEach(segment => {
        dict[segment.id] = {
            ...segment,
            icon: segment.icon || audience.icon,
            sortOrder: audience.sortOrder
        };
    });
    return dict;
}, {});

export function SegmentItem({ segment }) {
    return (
        <li className={styles.demographicTagListItem}>
            <FontAwesomeIcon icon={segment.icon} />{" "}
            <span className={styles.segmentLabel}>{segment.label}</span>
        </li>
    );
}

export default function QuoteCell({ quoteContent, segmentIds }) {
    const segments = segmentIds
        .filter(segmentId => {
            return segmentId && segmentId in SEGMENT_DICT;
        })
        .map(segmentId => SEGMENT_DICT[segmentId])
        .sort((a, b) => {
            return a.sortOrder > b.sortOrder;
        });

    return (
        <div className={styles.quoteCell}>
            <p className={styles.quoteText}>{quoteContent}</p>
            <ul className={styles.demographicTagList}>
                {segments.map(segment => (
                    <SegmentItem key={segment.id} segment={segment} />
                ))}
            </ul>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/Results/QuoteCell.js